import React, {Component, PropTypes} from 'react'
import {Tree, Input, Icon, message} from 'antd'
const TreeNode = Tree.TreeNode
const Search = Input.Search
import {API_CODE_SUCCESS, CLOSE_TIME} from '../../../config'
import debounce from 'debounce'

let departTree = []
const departSearchList = []
const generateList = (data) => {
	for (let i = 0; i < data.length; i++) {
		const node = data[i]
		const key = node.departmentId
		departSearchList.push({ key, title: node.title })
		if (node.children) {
			generateList(node.children, node.departmentId)
		}
	}
}

const getParentKey = (key, tree) => {
	let parentKey
	for (let i = 0; i < tree.length; i++) {
		const node = tree[i]
		if (node.children) {
			if (node.children.some(item => item.departmentId === key)) {
				parentKey = node.departmentId
			} else if (getParentKey(key, node.children)) {
				parentKey = getParentKey(key, node.children)
			}
		}
	}
	return parentKey
}

class SearchTree extends React.Component {

	static propTypes = {
		departmentTree: PropTypes.array,
		clickCallBackFunc: PropTypes.func
	}

	constructor(props) {
		super(props)
		this.state = {
			expandedKeys: [props.departmentTree[0].departmentId],
			searchValue: '',
			autoExpandParent: true,
			treeVisible: true,
			userInfo: {}
		}
		this.delayedUserDepartment = debounce(function (e) {
			const value = e.target.value.trim()
			this.setState({searchValue: value})
			if (value) {
				this.props.globalInquireUserDepartment(value).then(({retCode, retMsg}) => {
					const curreSearchValue = this.state.searchValue
					if (retCode === API_CODE_SUCCESS) {
						if (!!curreSearchValue) this.setState({treeVisible: false})
						else this.setState({treeVisible: true})
					} else {
						this.setState({treeVisible: true})
						message.error(retMsg, CLOSE_TIME)
					}
				})
			} else {
				this.setState({treeVisible: true})
			}
     }, 300)
	}

	treeNodeSelect = (selectKeys, e) => {
		if (this.props.clickCallBackFunc)
		{
			this.props.clickCallBackFunc(selectKeys[0])
		}
	}

	onExpand = (expandedKeys) => {
		this.setState({
			expandedKeys,
			autoExpandParent: false,
		})
	}
	onChange = (value) => {
		const expandedKeys = departSearchList.map((item) => {
			if (item.title.indexOf(value) > -1) {
				return getParentKey(item.key, departTree)
			}
			return null
		}).filter((item, i, self) => item && self.indexOf(item) === i)
		this.setState({
			expandedKeys,
			searchValue: value,
			autoExpandParent: true,
		})
	}

	onChangeHandle = (e) => {
		e.persist();
    this.delayedUserDepartment(e)
	}
	render() {
		departTree = this.props.departmentTree
		generateList(departTree)
		const { searchValue, expandedKeys, autoExpandParent, treeVisible, userInfo } = this.state
		const {filterUser, filterDepartment} = this.props

		const loop = data => data.map((item) => {
			if (item.children) {
				return (
						<TreeNode key={item.departmentId} title={item.title}>
							{loop(item.children)}
						</TreeNode>
				)
			}
			return <TreeNode key={item.departmentId} title={item.title} />
		})
		return (
				<div className="searchTree-w">
					<Search style={{ width: '100%' }} placeholder="搜索" onChange={this.onChangeHandle}/>
					<div style={{display: treeVisible ? '' : 'none'}}>
						<Tree 
							onExpand={this.onExpand}
							expandedKeys={expandedKeys}
							autoExpandParent={autoExpandParent}
							onSelect={this.treeNodeSelect}
						>
							{loop(departTree)}
						</Tree>
					</div>
					<div className="filterWrap" style={{display: !treeVisible ? '' : 'none'}}>
						{
							filterDepartment.length > 0 ? (
								<div className="filterDepartment-w">
									<div className="title">部门列表：</div>
									<ul className="filterDepartment-w">
										{
											filterDepartment.map(item => {
												return <li key={item.departmentId} onClick={() => this.props.onClickHandle('department', item.departmentId)}><Icon type="folder" /> {item.name}</li>
											})
										}
									</ul>
								</div>
							) : null
						}
						{
							filterUser.length > 0 ? (
								<div className="filterUser-w">
									<div className="title">员工列表：</div>
									<ul>
										{
											filterUser.map(item => {
												return <li key={item.uid} onClick={() => this.props.onClickHandle('user', item.uid)}><Icon type="user" /> {item.realName} | {item.email}</li>
											})
										}
									</ul>
								</div>
							) : null
						}
						{
							filterDepartment.length === 0 && filterUser.length === 0 && <div className="emptyTip">没有搜索结果!</div>
						}
					</div>
				</div>
		)
	}
}

export default SearchTree


// WEBPACK FOOTER //
// ./src/components/common/SearchTree/index.js